import APIClient from './index';
import _ from 'lodash';

export const getConciergePromptConfigs = (type = null) => {
  return new Promise((resolve, reject) => {
    const params = type ? `?type=${type}` : '';
    APIClient.get(`/ConciergePromptConfigs${params}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const createConciergePromptConfig = body => {
  return new Promise((resolve, reject) => {
    APIClient.post('/ConciergePromptConfigs', body)
      .then(response => resolve({ config: response.data }))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const updateConciergePromptConfig = (id, body) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`/ConciergePromptConfigs/${id}`, body)
      .then(response => resolve({ config: response.data }))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
